module.exports = __webpack_public_path__ + "static/media/Jet.7a8e9fca.svg";